import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { AssistantBlock, AssistantInline, parseAssistantMarkdown } from "../lib/assistantMarkdown";

const renderInline = (nodes: AssistantInline[]) =>
	nodes.map((node, index) => {
		if (node.type === "bold") {
			return (
				<strong key={index} className="font-semibold">
					{node.value}
				</strong>
			);
		}
		if (node.type === "link") {
			return (
				<Link key={index} to={node.to} className="text-primary font-medium underline underline-offset-2">
					{node.label}
				</Link>
			);
		}
		return <React.Fragment key={index}>{node.value}</React.Fragment>;
	});

const renderBlock = (block: AssistantBlock, index: number) => {
	if (block.type === "list") {
		const ListTag = block.ordered ? "ol" : "ul";
		return (
			<ListTag
				key={index}
				className={`space-y-1 ps-5 ${block.ordered ? "list-decimal" : "list-disc"} marker:text-muted-foreground`}
			>
				{block.items.map((item, itemIndex) => (
					<li key={itemIndex}>{renderInline(item)}</li>
				))}
			</ListTag>
		);
	}

	return <p key={index}>{renderInline(block.content)}</p>;
};

/** Renders an assistant reply: bold text, in-app links and step lists - never raw HTML. */
export const AssistantMessageContent: React.FC<{ text: string }> = ({ text }) => {
	const blocks = useMemo(() => parseAssistantMarkdown(text), [text]);
	return <div className="space-y-2 text-sm leading-6 break-words">{blocks.map(renderBlock)}</div>;
};
